import { GlobalVisibilityFormSchema } from "features/CenterContent/RoleContent/GlobalEvents/types/formSchema";
import { CustomTexts } from "features/CenterContent/RoleContent/GlobalEvents/types/responseSchema";
import { formatTime } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/utils";
import { VisibilityRequest } from "shared/form/visibilitySchema";
import { CountryCode } from "shared/types/countryCode";

export type GlobalEventRequest = {
  globalInformationType: "GLOBAL_GENERAL_WARNING";
  visibility: VisibilityRequest;
  incidentIds: string[];
  countryCode: CountryCode;
  customTexts: CustomTexts[];
};
export const getGlobalRequestVisibility = (
  visibility: GlobalVisibilityFormSchema,
): VisibilityRequest => ({
  type: "OPEN_ENDED",
  fromTime: formatTime(visibility.fromTime),
});
